//angular imports
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  Signal,
} from "@angular/core";

//local imports
import { ModuleNavigatedMessage } from "@app/core";
import {
  CatalogDataChangedMessage,
  CatalogHeaderModel,
  CatalogMenuModel,
} from "@app/catalog";
import { Messenger } from "@app/shared";

@Component({
  selector: "catalog-dashboard",
  templateUrl: "./catalog-dashboard.component.html",
  styleUrl: "./catalog-dashboard.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CatalogDashboardComponent implements AfterViewInit, OnDestroy {

  private moduleNavigatedMsg: Signal<ModuleNavigatedMessage>;
  private catalogDataChangedMsg: Signal<CatalogDataChangedMessage>;

  constructor(private messenger: Messenger) {
    this.moduleNavigatedMsg = this.messenger.getSignal(ModuleNavigatedMessage);
    this.catalogDataChangedMsg = this.messenger.getSignal(CatalogDataChangedMessage);
  }

  ngAfterViewInit(): void {
    const menuModel = new CatalogMenuModel();
    menuModel.initialize(this.messenger, this.moduleNavigatedMsg, this.catalogDataChangedMsg);
    
    this.messenger.send(
      new ModuleNavigatedMessage(
        new CatalogHeaderModel(),
        menuModel
      ),
    );
  }

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }
}
